import React from 'react';

type Props = {
  text: string;
};

export const Toast: React.FC<Props> = ({ text }) => (
  <div className="tw-pointer-events-none tw-absolute tw-top-3 tw-left-1/2 tw-z-50 tw--translate-x-1/2 tw-flex tw-items-center tw-gap-2 tw-bg-layout tw-rounded-[16px] tw-px-3 tw-py-2 tw-shadow-[0_4px_16px_rgba(0,0,0,0.12)] tw-animate-[fadeInDown_0.2s_ease]">
    <div className="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-rounded-full tw-bg-[#4CAF50] tw-flex tw-items-center tw-justify-center">
      <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
        <path
          d="M3 8l3.5 3.5L13 5"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
    <span className="tw-text-sm tw-font-medium tw-text-primary tw-whitespace-nowrap">
      {text}
    </span>
  </div>
);
